import Iconify from '@emfood/shared/src/components/iconify';

import { Box, useTheme, Typography } from '@mui/material';

interface Props {
  message: string;
}

export const BannerBox = ({ message }: Props) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 1,
        backgroundColor: theme.palette.warning.lighter,
        // zIndex: theme.zIndex.appBar,
      }}
    >
      <Box sx={{ ml: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <Iconify color={theme.palette.warning.dark} icon="solar:info-circle-bold" />
        <Typography color={theme.palette.warning.dark}>{message}</Typography>
      </Box>
    </Box>
  );
};
